module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.lib.libMerge({"options":{"@root":{"widgets.favico.widget":[{"value":"Favico","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101003},"path":"@root","_fox_":1}],"widgets.favico.handleWom.messageReceived.widget":[{"value":"@root #newMessageCount","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101005},"path":"@root","_fox_":1}],"widgets.favico.handleWom.messageReceived.event":[{"value":"cameNewMessages","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101006},"path":"@root","_fox_":1}],"widgets.favico.handleWom.messageReceived.callback":[{"value":function (data) {
if (data.total > 0) {
this.insertNumber(data.total);
return;
}
this.reset();
},"lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101014},"path":"@root","_fox_":1}]}}})
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/options/favico.js
// module id = 663
// module chunks = 4